import { Switch } from 'src/components';
import { Div, Icon, Text } from '@pinpoint/design-kit';
import CONSTANTS from 'src/store/constants';
import { formatNumber } from 'src/functions';
import React from 'react';
import PropTypes from 'prop-types';

export function LabeledCountPanel({ panelProps, titleProps, countProps, status, value, title }) {
  return (
    <Div border="1px solid" borderColor="shadeD9" rounded="md" {...panelProps}>
      <Text {...titleProps}>{title}</Text>
      <Switch status={status}>
        <Div {...countProps} value={CONSTANTS.API.STARTED}>
          <Icon name="Loading" />
        </Div>
        <Div value={CONSTANTS.API.SUCCEEDED}>
          <Text {...countProps}>{formatNumber(value)}</Text>
        </Div>
        <Div value={CONSTANTS.API.FAILED}>
          <Icon name="Alert" color="danger500" viewBox="0 0 22 22" />
        </Div>
        <Div value={null}>
          <Text {...countProps}>&#8212;</Text>
        </Div>
      </Switch>
    </Div>
  );
}

LabeledCountPanel.defaultProps = {
  panelProps: {},
  titleProps: {
    textColor: 'brand500',
    textSize: 'input',
  },
  countProps: {
    textColor: 'black',
    textSize: 'display1',
  },
  title: 'TITLE',
};

LabeledCountPanel.propTypes = {
  panelProps: PropTypes.shape({}),
  titleProps: PropTypes.shape({}),
  countProps: PropTypes.shape({}),
  status: PropTypes.oneOf([CONSTANTS.API.FAILED, CONSTANTS.API.STARTED, CONSTANTS.API.SUCCEEDED, null]).isRequired,
  value: PropTypes.number.isRequired,
  title: PropTypes.string,
};
